import React, { createRef } from 'react'
import { PlusOutlined, UploadOutlined } from '@ant-design/icons'
import {
  Form,
  Layout,
  Table,
  Input,
  Upload,
  Modal,
  Checkbox,
  Button,
  message,
  Tabs,
} from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import TestTable from './testTable'
import { API_DOMAIN, AD_DOMAIN } from '../../../config'
import { fetchData } from '../../../util'

const { Sider, Content } = Layout
const Search = Input.Search
const TabPane = Tabs.TabPane
const FormItem = Form.Item

class AdverLayout extends React.Component {
  static defaultProps = {
    advertSettingData: {
      display_time: '',
      picture: '0',
      video: '0',
      numbers: '',
      club_id: '0',
    },
  }

  constructor(props) {
    super(props)
    this.state = {
      previewVisible: false,
      previewImage: '',
      fileList: [],
      qiuNiuToken: '',
      club_id: '0',
      addVisible: false,
      addFileList: [],
      advertSettingState: {},
      videoVisible: false,
      videoSrc: '',
    }
  }

  handleCancel = () => this.setState({ previewVisible: false })

  handlePreview = (file) => {
    this.setState({
      previewImage: file.url || file.thumbUrl,
      previewVisible: true,
    })
  }

  handleChange = ({ fileList }, record, index) => {
    let list = this.state.fileList
    list[index] = fileList
    this.setState({ fileList: list })
    // 上传回调
    if (fileList[0] && fileList[0].response) {
      this.props.updateAd({ ...record, ad_url: fileList[0].response.url })
    }
  }

  onRowSelect = (record) => {
    this.setState({ club_id: record.id }, () => {
      this.props.fetchAdvertSetting(record.id)
      this.props.fetchAdvertList(record.id).then((res) => {
        const { advertList, advertSettingData } = this.props
        const list = advertList || []
        const fileList = list.map((v, i) => {
          return [
            {
              uid: '-' + (i + 1),
              name: 'xxx.png',
              status: 'done',
              url: AD_DOMAIN + '/' + v.ad_url.replace(/-normal/g, ''),
            },
          ]
        })
        this.setState({
          fileList,
          advertSettingState: advertSettingData || {},
        })
      })
    })
  }

  beforeUpload = async (file) => {
    const res = /(image\/png)|(image\/jpeg)/
    if (res.test(file.type)) {
      return await this.fetchQiuNiuToken()
    } else {
      this.setState({ qiuNiuToken: '' })
      message.error('只能上传 JPG/PNG 格式的图片！')
      return Upload.LIST_IGNORE
    }
  }

  fetchQiuNiuToken = () => {
    return new Promise((resolve, reject) => {
      const endpoint = `${API_DOMAIN}/SetClubApi/getToken`
      fetchData(endpoint).then((data) => {
        this.setState({ qiuNiuToken: data.token })
        resolve(true)
      })
    })
  }
  addFileChange = ({ fileList }) => {
    this.setState({ addFileList: fileList })
  }

  onFinish = (values) => {
    const { addFileList } = this.state
    const { advertList } = this.props
    if (addFileList.length === 0) {
      message.error('请上传广告图片!')
      return false
    }
    this.props.updateAd(
      {
        ad_url: addFileList[0].response.url,
        order_num: advertList[advertList.length - 1]
          ? +advertList[advertList.length - 1].order_num + 1
          : 1, // 排序 如果没数据从1开始
        display_time: values.display_time,
        no_display: values.no_display ? '1' : '0',
      },
      () => {
        this.setState({ addVisible: false })
      }
    )
  }

  advertSetting = () => {
    this.props.advertSetting(this.state.advertSettingState)
  }

  // 排序,其实就是调换2个顺序
  moveRow = (dragIndex, hoverIndex) => {
    const { advertList } = this.props
    this.props.updateOrder(
      {
        club_id: advertList[hoverIndex].club_id,
        id: advertList[hoverIndex].id,
        order_num: advertList[dragIndex].order_num, // 交换order_num
      },
      () => {
        this.props.updateOrder({
          club_id: advertList[dragIndex].club_id,
          id: advertList[dragIndex].id,
          order_num: advertList[hoverIndex].order_num,
        })
      }
    )
  }
  changObjData = (value) => {
    this.setState({
      advertSettingState: Object.assign(
        {},
        this.state.advertSettingState,
        value
      ),
    })
  }

  render() {
    const {
      previewVisible,
      previewImage,
      fileList,
      addVisible,
      addFileList,
      videoVisible,
      videoSrc,
    } = this.state
    const {
      advertList,
      advertSettingData: { numbers, video, picture, display_time },
    } = this.props

    const uploadButton = (
      <div>
        <PlusOutlined />
        <div className="ant-upload-text">Upload</div>
      </div>
    )

    const advertColumns = [
      {
        title: '广告',
        dataIndex: 'ad_url',
        key: 'ad_url',
        width: '20rem',
        render: (text, record, index) => {
          const list = [
            {
              uid: '-1',
              name: 'xxx.png',
              status: 'done',
              url: AD_DOMAIN + '/' + record.ad_url.replace(/-normal/g, ''),
            },
          ]
          if (+record.type === 1) {
            return (
              <div className="clearfix">
                <Upload
                  key={index}
                  action="//up-z2.qiniup.com/"
                  listType="picture-card"
                  defaultFileList={list}
                  data={{ token: this.state.qiuNiuToken }}
                  onPreview={this.handlePreview}
                  beforeUpload={this.beforeUpload}
                  onChange={(e) => {
                    this.handleChange(e, record, index)
                  }}
                  onRemove={(e) => {
                    let files = fileList
                    files[index] = []
                    this.setState({ fileList: files })
                  }}
                >
                  {fileList[index]
                    ? fileList[index].length >= 1
                      ? null
                      : uploadButton
                    : uploadButton}
                </Upload>
                <Modal
                  visible={previewVisible}
                  footer={null}
                  onCancel={this.handleCancel}
                >
                  <img
                    alt="example"
                    style={{ width: '100%' }}
                    src={previewImage}
                  />
                </Modal>
              </div>
            )
          } else {
            return (
              <div style={{ display: 'flex' }}>
                <video
                  style={{
                    width: '112px',
                    height: '112px',
                    border: '1px solid #e3e3e3',
                  }}
                  preload={'preload'}
                  src={AD_DOMAIN + '/' + record.ad_url.replace(/-normal/g, '')}
                >
                  你的浏览器不支持video标签
                </video>
                <div className={'video_image_box'}>
                  <Button
                    onClick={() => {
                      this.setState(
                        {
                          videoSrc:
                            AD_DOMAIN +
                            '/' +
                            record.ad_url.replace(/-normal/g, ''),
                          videoVisible: true,
                        },
                        () => {}
                      )
                    }}
                  >
                    播放
                  </Button>
                  <Upload
                    className={'zrs_upload_video zrs_upload_video_id' + index}
                    listType={'text'}
                    action="//up-z2.qiniup.com/"
                    data={{ token: this.state.qiuNiuToken }}
                    defaultFileList={list}
                    onPreview={this.handlePreview}
                    beforeUpload={this.beforeUpload}
                    onChange={(e) => {
                      this.handleChange(e, record, index)
                    }}
                    onRemove={(e) => {
                      let files = fileList
                      files[index] = []
                      this.setState({ fileList: files })
                    }}
                  >
                    <Button
                      onClick={() => {
                        const el = document.querySelector(
                          `.zrs_upload_video_id${index} .anticon-close`
                        )
                        el.click()
                      }}
                    >
                      <UploadOutlined /> 重新上传
                    </Button>
                  </Upload>
                </div>
              </div>
            )
          }
        },
      },
      {
        title: '显示时长(单位：秒)',
        dataIndex: 'display_time',
        key: 'display_time',
        align: 'center',
        width: '20rem',
        render: (text, record, index) => {
          return (
            <Input
              onBlur={(e) => {
                this.props.updateAd(
                  Object.assign({}, record, {
                    display_time: e.target.value,
                    update: true,
                  })
                )
              }}
              defaultValue={record.display_time}
            />
          )
        },
      },
      {
        title: '是否显示',
        dataIndex: 'no_display',
        key: 'no_display ',
        align: 'center',
        width: '20rem',
        render: (text, record, index) => {
          return (
            <Checkbox
              onChange={(e) => {
                this.props.displayAd({
                  no_display: e.target.checked ? 1 : 0,
                  id: record.id,
                })
              }}
              defaultChecked={+record.no_display === 1}
            >
              不显示
            </Checkbox>
          )
        },
      },
      {
        title: '操作',
        dataIndex: 'edit',
        key: 'edit',
        align: 'center',
        render: (text, record, index) => {
          return (
            <div style={{ color: '#108EE9', cursor: 'default' }}>
              <Popconfirm
                title={'你确认要删除此广告吗?'}
                okText="确认"
                cancelText="取消"
                onConfirm={() =>
                  this.props.delAd({
                    id: record.id,
                    club_id: this.state.club_id,
                  })
                }
              >
                <span style={{ color: 'red' }}>删除 </span>
              </Popconfirm>
            </div>
          )
        },
      },
    ]
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
      },
    }

    return (
      <Layout>
        <Content className={'zrs_layout'}>
          <Tabs style={{ paddingLeft: '10px' }} defaultActiveKey="1">
            <TabPane tab="广告列表" key="1">
              <Button
                type="primary"
                onClick={() => this.setState({ addVisible: true })}
              >
                添加广告
              </Button>
              {/* <Table
                rowKey="id"
                columns={advertColumns}
                dataSource={advertList}
                onRow={record => {
                  return {
                    onClick: event => { this.onRowSelect(record) }, // 点击行
                  };
                }}
              /> */}
              <TestTable
                scroll={{ y: 500 }}
                moveRow={this.moveRow}
                rowKey="id"
                columns={advertColumns}
                dataSource={advertList}
              />
            </TabPane>
            <TabPane tab="权限管理" key="2">
              <div className={'advert_mag_div'}>
                <span>是否可以上传广告</span>
                <Checkbox
                  defaultChecked={+picture}
                  onChange={(e) => {
                    this.changObjData({ picture: e.target.checked ? '1' : '0' })
                  }}
                  style={{ marginLeft: '15px' }}
                />
              </div>
              <div className={'advert_mag_div'}>
                <span>是否可以上传视频</span>
                <Checkbox
                  defaultChecked={+video}
                  onChange={(e) => {
                    this.changObjData({ video: e.target.checked ? '1' : '0' })
                  }}
                  style={{ marginLeft: '15px' }}
                />
              </div>
              <div className={'advert_mag_div'}>
                <span>图片最大显示时间</span>
                <Input
                  defaultValue={display_time}
                  onChange={(e) => {
                    this.changObjData({ display_time: e.target.value })
                  }}
                  className={'advert_mag_input'}
                  type={'number'}
                  placeholder={'请输入时间'}
                />
                <span>秒</span>
              </div>
              <div className={'advert_mag_div'}>
                <span>图片最多显示数量</span>
                <Input
                  defaultValue={numbers}
                  onChange={(e) => {
                    this.changObjData({ numbers: e.target.value })
                  }}
                  className={'advert_mag_input'}
                  type={'number'}
                  placeholder={'请输入数量'}
                />
              </div>
              <div className={'advert_mag_div'}>
                <Button type={'primary'} onClick={this.advertSetting}>
                  确认
                </Button>
              </div>
            </TabPane>
          </Tabs>
        </Content>
        <Modal
          title="添加广告"
          visible={addVisible}
          onOk={this.handleOk}
          onCancel={() => this.setState({ addVisible: false, addFileList: [] })}
          footer={null}
        >
          <Form onFinish={this.onFinish}>
            <FormItem {...formItemLayout} label={'广告图片'}>
              <Upload
                action="//up-z2.qiniup.com/"
                listType="picture-card"
                fileList={addFileList}
                data={{ token: this.state.qiuNiuToken }}
                onPreview={this.handlePreview}
                beforeUpload={this.beforeUpload}
                onChange={this.addFileChange}
              >
                {addFileList.length >= 1 ? null : uploadButton}
              </Upload>
              <span style={{ color: '#ccc' }}>建议尺寸：1280 x 720</span>
            </FormItem>
            <FormItem
              {...formItemLayout}
              name="display_time"
              rules={[{ required: true, message: '请输入显示时长!' }]}
              label={'显示时长'}
            >
              <Input
                style={{ width: '80%' }}
                type="number"
                placeholder="请输入显示时长"
              />
              <span style={{ margin: '5px' }}>秒</span>
            </FormItem>
            <FormItem {...formItemLayout} name="no_display" label={'不显示'}>
              <Checkbox />
            </FormItem>
            <FormItem style={{ width: '100%' }}>
              <div style={{ float: 'right' }}>
                <Button type="primary" htmlType="submit">
                  添加
                </Button>
                <Button
                  style={{ marginLeft: '20px' }}
                  type="default"
                  onClick={() => this.setState({ addVisible: false })}
                >
                  取消
                </Button>
              </div>
            </FormItem>
          </Form>
        </Modal>
        <Modal
          title="视频播放"
          visible={videoVisible}
          onCancel={() => this.setState({ videoVisible: false })}
          footer={null}
        >
          <div style={{ width: '100%', textAlign: 'center' }}>
            <video
              controls={'controls'}
              style={{ height: '60vh' }}
              id={'playVideo'}
              preload={'preload'}
              src={videoSrc}
            >
              你的浏览器不支持video标签
            </video>
          </div>
        </Modal>
      </Layout>
    )
  }
}

export default AdverLayout



// WEBPACK FOOTER //
// ./src/containers/AdvertManage/component/layout.js